/**
 * Converts a file object to a data URI that can be sent in a JSON payload.
 * Data URIs look like `data:<media_type>;base64,<base64_data>`
 * https://en.wikipedia.org/wiki/Data_URI_scheme
 */
export default function fileToDataURI(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      if (!reader.result) {
        reject("FileReader missing result after load, this shouldn't happen")
        return
      }
      resolve(reader.result.toString())
    }
    reader.onerror = reject
  })
}
